import React, { useState } from 'react';
import { Button, message } from 'antd';
import { CheckCircleFilled, CopyOutlined } from '@ant-design/icons';
import { SingleUsePassCreationController } from 'fragments/passcodes/fragments/single-use-pass-creation/interfaces';
import { useTranslator } from 'tools/view-hooks/translator-hook';

export const SingleUsePassSuccess: React.FC<{ controller: SingleUsePassCreationController }> = ({ controller }) => {
    const { translate } = useTranslator();
    const [copied, setCopied] = useState(false);
    const code = controller.created?.code ?? '';
    const lock = controller.selectedLock;

    const onCopy = () => {
        navigator.clipboard?.writeText(code).then(() => {
            setCopied(true);
            message.success(translate({ key: 'visitor-pass.copied' }));
            setTimeout(() => setCopied(false), 2500);
        });
    };

    return (
        <div className={'sup-creation'}>
            <div className={'sup-creation-success'}>
                <CheckCircleFilled className={'sup-creation-check'} aria-hidden />
                {lock && (
                    <div className={'sup-creation-lock'}>
                        {lock.site_name} · {lock.lock_name}
                    </div>
                )}
                <div className={'sup-creation-code'}>{code}</div>
                {controller.validUntil && (
                    <div className={'sup-creation-valid'}>
                        {translate({ key: 'visitor-pass.valid-until', extra: { end: controller.validUntil } })}
                    </div>
                )}
                <Button className={'sup-creation-copy'} icon={<CopyOutlined />} onClick={onCopy}>
                    {copied ? translate({ key: 'visitor-pass.copied' }) : translate({ key: 'visitor-pass.copy' })}
                </Button>
                <div className={'sup-creation-instruction'}>{translate({ key: 'visitor-pass.code-instruction' })}</div>

                <Button
                    type={'primary'}
                    style={{ width: '100%', height: 48, borderRadius: 8 }}
                    onClick={controller.onShare}
                >
                    {translate({ key: 'visitor-pass.share-both' })}
                </Button>
                <Button type={'link'} className={'sup-creation-share-secondary'} onClick={controller.onShareCodeOnly}>
                    {translate({ key: 'visitor-pass.share-code-only' })}
                </Button>
                <div className={'sup-creation-share-reason'}>{translate({ key: 'visitor-pass.share-reason' })}</div>

                <Button type={'text'} style={{ marginTop: '1.5rem' }} onClick={controller.reset}>
                    {translate({ key: 'visitor-pass.generate-other' })}
                </Button>
            </div>
        </div>
    );
};
